<template>
  <section :class="{'purchases purchases--lk': !successFormVisibled, message: successFormVisibled}">
    <app-loading :is-loading="isLoading" />

    <div
      v-if="successFormVisibled"
      class="container"
    >
      <div class="row">
        <div class="col-12">
          <div class="message__title-wrapper message__title-wrapper--purchase">
            <h1 class="message__section-title message__section-title--black">
              {{ title }}
            </h1>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-8 offset-md-2">
          <div class="message__wrapper">
            <div class="message__subtitle-wrapper">
              <img
                class="message__img"
                src="~@/assets/img/icons/Shield-success.svg"
                alt="Операция прошла успешно"
                width="100"
                height="100"
              >
              <h3 class="message__title message__title--success">
                Успешно!
              </h3>
            </div>
            <div class="message__text-wrapper">
              <p class="message__text">
                {{ title }} успешно отправлен.
              </p>
              <p class="message__text">
                Ответ на ваш запрос будет отправлен на адрес электронной почты контактного лица. Также с ответом можно
                будет ознакомиться в Личном кабинете в разделах <router-link :to="{ name: 'PageUnderConstruction', params: { title: 'Уведомления' } }">
                  Уведомления
                </router-link>
              </p>
            </div>
            <div
              v-if="!hasRole('customer')"
              class="message__button"
            >
              <router-link
                :to="{ name: 'ActualPurchases' }"
                class="message__link"
              >
                В актуальные закупки
              </router-link>
            </div>
            <div
              v-else
              class="message__button"
            >
              <router-link
                :to="{ name: 'ClarificationsList' }"
                class="message__link"
              >
                В список запросов на разъяснение
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="!isLoading && !successFormVisibled">
      <div class="container">
        <div
          v-if="clarificationDetail.general"
          class="row"
        >
          <div class="col-12">
            <div class="purchases__title-wrapper">
              <h2 class="purchases__title">
                {{ title }}
              </h2>
              <div class="row">
                <div class="col-9">
                  <div class="purchases__form purchases__form--disabled">
                    <div class="purchases__form-title-wrapper">
                      <h3 class="purchases__form-title">
                        {{ clarificationDetail.general.title }}
                      </h3>
                    </div>
                    <DetailsSectionCommon
                      v-for="item in clarificationDetail.general.items"
                      :key="item.name"
                      :data="item"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-for="message in clarificationDetail.messages"
        :key="message.createdAt"
        class="container"
      >
        <div
          class="purchases__form"
          :class="{
            'purchases__form--customer': isCustomerMessage(message)
          }"
        >
          <div class="row">
            <div class="col-12">
              <div class="purchases__form-title-wrapper">
                <h3
                  v-if="isCustomerMessage(message)"
                  class="purchases__form-title"
                >
                  Текст ответа
                </h3>
                <h3
                  v-else
                  class="purchases__form-title"
                >
                  Текст запроса
                </h3>
              </div>
              <div class="purchases__form-block">
                <div class="row">
                  <div class="col-12">
                    <div class="user-text">
                      {{ message.message }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Files
          v-if="message.documents && message.documents.length"
          title="Документы"
          disabled
          :files="[]"
          :old-files="message.documents"
        />

        <hr>
      </div>

      <div class="container">
        <div class="purchases__form">
          <div class="row">
            <div class="col-12">
              <div class="purchases__form-title-wrapper">
                <h3
                  v-if="!hasRole('customer')"
                  class="purchases__form-title"
                >
                  Текст запроса
                </h3>
                <h3
                  v-else
                  class="purchases__form-title"
                >
                  Текст ответа
                </h3>
              </div>
              <div class="purchases__form-block">
                <div class="row">
                  <div class="col-12">
                    <textarea
                      v-model="message"
                      class="purchases__textarea purchases__textarea--limit"
                      placeholder="Введите текст"
                      :disabled="!canSend"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Files
          v-model:files="files"
          title="Документы"
          :disabled="!canSend"
        />
      </div>

      <div class="container">
        <div class="purchases__form-buttons purchases__form-buttons--mt buttons-list-right">
          <div v-if="!hasRole('customer')">
            <ButtonForm
              v-if="canSend"
              :disabled="!message"
              label="Подать запрос на разъяснения"
              @click="sendClarification"
            />
          </div>
          <div v-else>
            <ButtonForm
              v-if="canSend"
              :disabled="!message"
              label="Подать ответ"
              @click="sendClarification"
            />
          </div>
          <div>
            <router-link
              v-slot="{ navigate }"
              :to="{ name: 'ActualPurchases' }"
              custom
            >
              <ButtonForm
                role="link"
                type="button"
                color="white"
                label="Вернуться к закупкам"
                @click="navigate"
                @keypress.enter="navigate"
              />
            </router-link>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import DetailsSectionCommon from '@/components/details/DetailsSectionCommon.vue';
import Files from '@/components/blocks/Files';
import ButtonForm from '@/components/form/button-form.vue';

export default {
  name: 'Request',
  components: {
    ButtonForm,
    Files,
    DetailsSectionCommon,
  },
  data() {
    return {
      id: null,
      lotId: null,
      message: '',
      files: [],
      successFormVisibled: false,
      isLoading: true,
    };
  },
  created() {
    this.lotId = this.$route.params.lotId;
    this.id = this.$route.params.id;
  },
  async mounted() {
    await this.loadInfo();
    await this.loadDetail();
  },
  computed: {
    ...mapState({
      clarificationDetail: (state) => state.lots.clarificationDetail,
    }),
    ...mapGetters({
      hasRole: 'user/hasRole',
    }),
    canSend() {
      return true;
    },
    title() {
      const number = (
        this.clarificationDetail.general?.items?.find((item) => item.name === 'purchaseNumber') || {}
      ).value;
      return `Запрос на разъяснения закупки №${number}`;
    },
  },
  methods: {
    ...mapActions({
      loadInfo: 'user/loadInfo',
      loadLotDetail: 'lots/loadLotDetail',
      clarificationCreate: 'lots/clarificationCreate',
      loadClarificationDetail: 'lots/loadClarificationDetail',
    }),
    async loadDetail() {
      await this.loadClarificationDetail({ lotId: this.lotId, id: this.id });
      this.isLoading = false;
      this.files = [];
      this.message = '';
    },
    clickPage(number) {
      this.currentPage = Number(number);
    },
    async sendClarification() {
      this.isLoading = true;
      try {
        const params = {
          message: this.message,
          documents: this.files.map((file) => file.id),
        };
        if (this.id) {
          params.clarificationId = +this.id;
        } else {
          params.lotId = +this.lotId;
        }
        await this.clarificationCreate(params);
        this.isLoading = false;
        this.successFormVisibled = true;
      } catch (e) {
        alert(e.response.data.description);
        this.isLoading = false;
      }
    },
    isCustomerMessage(message) {
      if (message.isUserMessage && this.hasRole('customer')) {
        return true;
      }

      if (!message.isUserMessage && !this.hasRole('customer')) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.row--end {
  justify-content: flex-end;
}
.purchases__form--customer{
  text-align: right;
}
.purchases__form-title{
  width: 100%;
}
</style>
